import { render, staticRenderFns } from "./SharedEditDialog.vue?vue&type=template&id=90bd3476&scoped=true&"
import script from "./SharedEditDialog.vue?vue&type=script&lang=js&"
export * from "./SharedEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./SharedEditDialog.vue?vue&type=style&index=0&id=90bd3476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bd3476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VDialog,VDivider,VIcon,VSpacer})
